/**
 * Lock only the first occurrence of each value in `disabledValues`.
 * Later duplicates (e.g. user-pasted hardcoded OAuth redirect URI) stay editable/deletable.
 */
export const isDisabledFieldValue = (
  value: string,
  index: number,
  allValues: string[],
  disabledValues?: string[]
): boolean => Boolean(disabledValues?.includes(value)) && allValues.indexOf(value) === index;
